var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.providers),function(p){return _c('li',{key:p.provider},[_c('router-link',{class:{
				inactive: p.provider != _vm.currentProvider
			},attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.setCurrentProvider(p.provider)}}},[_vm._v("\n\t\t\t\t"+_vm._s(p.name)+"\n\t\t\t")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }